var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-admin"},[_c('div',{staticClass:"admin-message"},[_vm._v("\n    请到管理员后台进行操作\n  ")])])
}]

export { render, staticRenderFns }